import { render, staticRenderFns } from "./All.vue?vue&type=template&id=b2d836a6&"
import script from "./All.vue?vue&type=script&lang=js&"
export * from "./All.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports